import styled from 'styled-components';

interface ItemProps {
  readonly membershipCount?: number;
  readonly errorPayment?: string;
}

export const SponsorshipSection = styled.div`
  border-left: 1px solid #e8e9ed;
  padding: 0;
  flex-direction: column;
  align-items: normal;
  display: flex;
  justify-content: center;
  width: calc(100% - 2px);

  @media (max-width: 720px) {
    padding: 30px 30px 0 30px;
    border: none;
    min-width: 300px;
  }
`;

export const SponsorshipRadios = styled.div`
  border-bottom: 1px solid #e8e9ed;
  display: flex;
  justify-content: center;
  padding: 45px 0 38px 0;
  width: 100%;
`;

export const SponsorshipTitle = styled.h2`
  color: #414042;
  margin: 0;
  font-size: 25px;
  font-weight: 600;
`;

export const SponsorshipSubtitle = styled.p`
  color: #414042;
  margin: 0 0 25px;
  font-size: 19px;
  font-weight: normal;
`;

export const SponsorshipHeader = styled.div`
  justify-content: flex-start;
  display: flex;
  padding: 20px 0;

  @media (max-width: 758px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    & > div {
      margin: 0;
      margin-top: 10px;
    }
  }
`;

export const SponsorshipLevelCard = styled.div`
  justify-content: space-between;
  border: 1px solid #e5e5e5;
  align-items: center;
  border-radius: 10px;
  padding-left: 50px;
  display: flex;
`;

export const BlockWrapper = styled.div`
  max-width: 680px;
  padding: 65px 0 50px 98px;
`;

export const SponsorshipBody = styled.div`
  justify-content: center;
  margin: 0 0px;
  display: flex;
  flex-wrap: wrap;
`;

export const SponsorshipLevelDiscount = styled.div`
  background-color: #334355;
  border-radius: 10px;
  margin-left: 20px;
  cursor: pointer;
`;

export const SponsorshipDiscountHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 20px 0; ;
`;

export const SponsorshipDiscountHeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 20px;
`;

export const SponsorshipDiscountHeaderRight = styled.div`
  border-bottom-left-radius: 11px;
  padding: 10px 90px 10px 10px;
  border-top-left-radius: 11px;
  background-color: #f54b23;
  justify-content: flex-start;
  font-weight: 600;
  margin-left: 30px;
  font-size: 32px;
  display: flex;
  color: #fff;
`;

export const SponsorshipDiscountHeaderTitle = styled.span`
  color: #ffffff;
  text-align: left;
  font-weight: 400;
  font-size: 15px;
`;

export const SponsorshipDiscountHeaderSubtitle = styled.span`
  color: #ffffff;
  font-weight: 500;
  font-size: 20px;
`;

export const SponsorshipDiscountFooter = styled.div`
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #5d6e81;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  font-size: 15px;
  color: #fff;
  display: flex;
`;

export const SponsorshipLevelHeader = styled.th`
  text-transform: uppercase;
  text-align: start;
  color: #3e464e;
  font-weight: 600;
  font-size: 15px;
  width: 160px;
`;

export const SponsorshipLevelLeft = styled.td`
  width: max-content;
  text-align: left;
  color: #5d6e81;
  font-size: 13px;
`;

export const SponsorshipLevelRight = styled.td`
  text-align: left;
  font-weight: 600;
  color: #5d6e81;
  font-size: 13px;
`;
export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
`;

export const LabelDropdown = styled.div`
  color: rgba(62, 70, 78, 1);
  font-family: 'Proxima Nova';
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.66px;
  line-height: 29px;
`;
export const LabelAddCard = styled.div`
  color: rgba(0, 122, 255, 1);
  font-family: 'Proxima Nova';
  font-size: 10px;
  cursor: pointer;
  letter-spacing: 0.55px;
  line-height: 29px;
  margin: 0px 0px 0px auto;
  text-decoration: underline;
`;
export const TableLabel = styled.div`
  color: rgba(65, 64, 66, 1);
  font-family: 'Proxima Nova';
  font-size: 25px;
  font-weight: bold;
  letter-spacing: -0.63px;
  line-height: 25px;
  flex-grow: 1;
  margin: 20px 0 10px 0;
`;

export const TableSubtitle = styled.p`
  font-size: 19px;
  color: #414042;
  margin: 0 0 25px;
`;

export const UploadFileWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const UploadFile = styled.div`
  position: relative;
`;

export const ButtonUpload = styled.button`
  background-color: #ACB1C0;
  color: #FFF;
  cursor: pointer;
  border: 0;
  padding: 9px 29px;
  border-radius: 8px;
`;

export const UploadHelpText = styled.span`
  color: #5D6E81;
  font-size: 12px;
  display: inline-block;
  padding-left: 10px;
`;

export const FormBlock = styled.div`
  max-width: 100%;
`;

export const FormBlockGray = styled.div`
  background-color: #FCFCFC;
  max-width: 290px;
  margin-top: 15px;
  padding: 25px 0;
  & > div {
    padding: 0px 25px;
    border: 0;
    margin-bottom: 5px;
  }
`;

export const FormControl = styled.div`
  margin-bottom: 20px;
  p {
    margin: 0 0 5px;
  }
`;

export const ChoosePaymentRadios = styled.div`

`;

export const ButtonWrapper = styled.div`
  padding-top: 10px;
`;

export const TableSimple = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 20px;
  width: 100%;
  thead {
    th{
      background-color: #858CA0;
      color: #FFF;
      border-radius: 8px 8px 0 0;
      font-size: 16px;
      padding: 18px 35px 14px 35px;
      text-transform: uppercase;
      text-align: left;
    }
  }
  tbody {
    tr{
      td {
        color: #424854;
        text-align: left;
        font-size: 15px;
        font-weight: 600;
        padding: 12px 10px;
        text-align: center;
        &:first-child{
          border-left: 1px solid #BAC1C9;
        }
        &:last-child{
          border-right: 1px solid #BAC1C9;
        }
      }
      &:nth-child(even){
        td{
          background-color: rgba(186, 193, 201, 0.09);
        }
      }
      &:first-child{
        td {
          color: #5D6E81;
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
      &:last-child{
        td {
          border-bottom: 1px solid #BAC1C9;
          &:first-child{
            border-radius: 0 0 0 8px;
          }
          &:last-child{
            border-radius: 0 0 8px 0;
          }
        }
      } 
    }
  }
`;
export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-width:860px;  
  @media (max-width: 720px) {
    flex-direction: column;
    min-width: 300px;
  }
`;

export const SectionLeft = styled.div`
  border-right: 2px solid #e8e9ed;
  padding: 40px 106px 50px;
  background-color: #FCFCFC;
  min-height: 600px;
  width: 50%;
`;

export const SectionRight = styled.div`
  padding: 40px 162px 50px 61px;
  max-width: 450px;
  width: 50%;
`;

export const MonthlyMemberShip = styled.div`
  display: flex;
  border: 1px solid #BAC1C9;
  border-radius: 8px;
  overflow: hidden;
`;

export const MonthlyMemberShipDark = styled.div`
  background-color: #334355;
  color: #FFF;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
  padding: 0 28px;
  display: flex;
  align-items: center;
  max-width: 170px;
  box-sizing: border-box;
  line-height: 19px;
`;

export const MonthlyMemberShipLight = styled.div`
  display: flex;
  text-align: center;
  padding: 30px 35px;
  & sup {
    color: #424854;
    font-size: 31px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 47px;
    text-align: center;
  }
  & span {
    color: #424854;
    font-size: 75px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 75px;
    text-align: center;
  }
`;

export const TotalSection = styled.div`
  border-top: 1px solid #E5E5E5;
  padding-top: 15px;
`;

export const TotalSectionLabel = styled.label`
  color: #3E464E;
  display: block;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const TotalSectionValue = styled.div`
  color: #3E464E;
  font-weight: 600;
  font-size: 38px;
`;

export const MonthlyBox = styled.div`
  display: flex;
  border-radius: 8px;
  width: fit-content;
  margin-bottom: 25px;
  overflow: hidden;
  box-sizing: border-box;
  min-width: 313px;
  width: 100%;

  @media (max-width: 1000px) {
    width:100%;
    margin: 0px 0px;
  }
`;
export const MonthlyBoxText = styled.div`
  width: 55%;
  align-items: center;
  background-color: #334355;
  color: #FFF;
  display: flex;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  text-transform: uppercase;
  padding: 25.95px 19px 25.06px 28px;
`;
export const MonthlyBoxValue = styled.div`
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid #BAC1C9;  
  border-left: 0;
  align-items: center;
  color: #424854;
  display: flex;
  font-weight: 500;
  padding: 8px 16px;
  justify-content: center;
  width: 45%;

  & sup {
    font-size: 30px;
    position: relative;
    top: -12px;
  }
  & span{
    font-size: 62px;
  }
`;

export const AvailableBox = styled.div<ItemProps>`
  position: relative;
  height: 106px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  margin-bottom: 10px;
  width: 100%;
  min-width: 260px;
  border: ${props => props.membershipCount ? "none" : "1px solid #BAC1C9"};
  background: ${props => props.membershipCount ? "#F54B23" : "white"};
  color: ${props => props.membershipCount ? "white" : "#2B323B"};

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;
export const AvailableBoxTop = styled.div`
  display: flex;
  align-items: center;
  padding: 11px 15px;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
`;
export const AvailableBoxTitle = styled.span`
  display: flex;
  font-size: 16px;
  font-weight: 700;
  flex-direction: column;
  text-transform: uppercase;  
  font-family: 'Proxima Nova';
  letter-spacing: 0.886154px;
  font-style: normal;
  line-height: 19px;

`;
export const AvailableBoxValue = styled.span<ItemProps>`
  background: ${props => props.membershipCount ? "white" : "#38424D"};
  color: ${props => props.membershipCount ? "#F54B23" : "white"};
  box-sizing: border-box;
  border-radius: 50%;
  display: inline-block;
  font-size: 32px;
  font-weight: 600;
  height: 46px;
  line-height: 46px;
  padding: 0 5px;
  margin-right: 15px;
  text-align: center;
  min-width: 46px;
`;
export const AvailableBoxBottom = styled.div<ItemProps>`
  background: ${props => props.membershipCount ? "#E74621" : "rgba(240,240,240,0.37)"};
  color: ${props => props.membershipCount ? "white" : "#5D6E81"};
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  padding: 11px 22px 13px 26px;
  text-align: center;
  width: 100%;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const Taxes = styled.p`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  letter-spacing: 0.830769px;
  text-transform: uppercase;
  color: #3E464E;
  margin-bottom: 0;
`;

export const ModalPayment = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContentModalPayment = styled.div`
  padding: 25px;
  display: flex;
  justify-content: center;
`

export const TitleModalPayment = styled.span<ItemProps>`
  margin: 0;
  font-size: 26px;
  font-weight: 500;
  text-align: center;  
  color: ${props => props.errorPayment === 'error' ? 'var(--PrimaryRed)' : props.errorPayment === 'success' ? '#07bc0c' : '#000'}
`

export const TextModalPayment = styled.span`
margin: 0;
font-size: 15px;
font-weight: 500;
padding: 30px 0;
text-align: center;
color: var(--DarkGray);
`

export const ModalPaymentButton = styled.div`
display: flex;
justify-content: flex-end;
`